import React from 'react'

function Copyright() {
  return (
    <footer>Copyright ©️ 2022 || {'<'+'Designed and coded by Tanmaya Biswal'+'>'} ||</footer>
  )
}

export default Copyright;